const bookmark = state => state.bookmark.data
const error = state => state.error
const isLoading = state => state.isLoading
const bookmarkDetails = state => state.bookmarkDetails.data
const isErrorBookmarkDetails = state => state.isErrorPromoDetails
const isLoadingBookmarkDetails = state => state.isLoadingPromoDetails
const postBookmark = state => state.postBookmark.data
const isErrorPostBookmark = state => state.isErrorPostBookmark
const isLoadingPostBookmark = state => state.isLoadingPostBookmark
const deleteBookmark = state => state.deleteBookmark.data
const isLoadingDeleteBookmark = state => state.isLoadingDeleteBookmark
const errorDeleteBookmark = state => state.errorDeleteBookmark

export default {
  isLoading,
  bookmark,
  error,
  bookmarkDetails,
  isErrorBookmarkDetails,
  isLoadingBookmarkDetails,
  postBookmark,
  isErrorPostBookmark,
  isLoadingPostBookmark,
  deleteBookmark,
  isLoadingDeleteBookmark,
  errorDeleteBookmark
}



// WEBPACK FOOTER //
// ./src/store/modules/bookmark/getters.js